/*eslint-disable*/
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  message: '',
}

const userBannerSlice = createSlice({
  name: 'userBanner',
  initialState,
  reducers: {
    setUserBanner: (state, action) => {
      state.message = action.payload.message
    },
    resetUserBanner: (state) => {
      state.message = ''
    }
  },
})

export default userBannerSlice.reducer

// selectors
export const selectUserBannerObject = (state) => state.userBanner

// export actions
export const { setUserBanner, resetUserBanner } = userBannerSlice.actions
